<template>
  <div class="changestate">
    <ChangeDetail v-if="isDetail" :id="id" @close="close"></ChangeDetail>
    <div v-else>
      <ul class="changestateul">
        <li
          v-for="(tab, index) in tabs"
          @click="toggle(index, tab.view)"
          :class="{ active: active == index }"
          :key="index"
        >
          {{ tab.type }}
          <span v-if="index == 1 && countMessage && countMessage.doingCount > 0">
            ({{ countMessage.doingCount }})
          </span>
        </li>
      </ul>
      <div class="clearfix"></div>
      <!--:is实现多个组件实现同一个挂载点-->
      <component :is="currentView" @show="showDetail"></component>
    </div>
  </div>
</template>

<script>
import ChangeStatefirst from "./ChangeStatefirst";
import ViewStatus from "./ViewStatus";
import ViewTrack from "./ViewTrack";
import ChangeDetail from "./changeDetail";
export default {
  name: "ChangeState",
  components: {
    ChangeStatefirst,
    ViewStatus,
    ViewTrack,
    ChangeDetail,
  },
  data: function () {
    return {
      active: 0,
      currentView: "ChangeStatefirst",
      tabs: [
        {
          type: "申请类别",
          view: "ChangeStatefirst",
        },
        {
          type: "审批中",
          view: "ViewStatus",
        },
        {
          type: "已办结",
          view: "ViewTrack",
        },
      ],
      countMessage: null,
      isDetail: false,
      id: "",
    };
  },
  created() {
    this.getCount();
  },
  methods: {
    toggle(i, v) {
      this.active = i;
      this.currentView = v;
    },
    async getCount() {
      let res = await this.axios.get(`/biz/archive/apply/count`);
      this.countMessage = res.result;
    },
    showDetail(e) {
      this.id = e.id;
      this.isDetail = true;
    },
    close(type) {
      if (type) {
        this.getCount();
      }
      this.isDetail = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.changestate {
  background: $bgcontent;
  min-height: 500px;
  padding: 28px;

  .changestateul li {
    float: left;
    margin-right: 30px;
    width: 108px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    color: #999999;
    cursor: pointer;
    text-align: center;
    border-radius: 3px;

    &.active {
      background: $bgColor;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/ChangeState.vue